import { useCallback, useState } from "react"
import type { AgentExecutionLight } from "@stockline/shared/types/ai/execution"
import { EXECUTION_TABLE } from "../../../lib/offline/resources/ai/execution/db"
import { useAISync } from "../providers/AISyncProvider"

export interface UseCancelExecutionReturn {
  cancel: (id: string) => Promise<void>
  pending: boolean
}

export function useCancelExecution(): UseCancelExecutionReturn {
  const { storage, changeQueue, engine } = useAISync()
  const [pending, setPending] = useState(false)

  const cancel = useCallback(
    async (id: string): Promise<void> => {
      setPending(true)
      try {
        const existing = await storage.get<AgentExecutionLight>(
          EXECUTION_TABLE,
          id
        )
        if (!existing) return

        const updated: AgentExecutionLight = {
          ...existing,
          status: "cancelled",
        }

        await storage.put(EXECUTION_TABLE, updated)
        await changeQueue.enqueue("executions", {
          op: "update",
          id,
          data: { status: "cancelled" },
        })
        void engine.pushChanges("executions")
      } finally {
        setPending(false)
      }
    },
    [storage, changeQueue, engine]
  )

  return { cancel, pending }
}
